import { render, staticRenderFns } from "./PasswordResetSendMailResult.vue?vue&type=template&id=42c7e107&scoped=true&"
import script from "./PasswordResetSendMailResult.vue?vue&type=script&lang=js&"
export * from "./PasswordResetSendMailResult.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetSendMailResult.vue?vue&type=style&index=0&id=42c7e107&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c7e107",
  null
  
)

export default component.exports